@switch (getCurrentTab()) {
  @case (TabQueryParams.Vulnerabilities) {
    <app-ui-drawer [isOpen]="vulnerabilityFindingsSideDrawerService.isDrawerOpen()"
                   (closed)="vulnerabilityFindingsSideDrawerService.closeDrawer()"
                   [isLoading]="vulnerabilityFindingsSideDrawerService.isLoading()"
                   [isEmpty]="vulnerabilityFindingsSideDrawerService.isEmpty()"
                   [noResultsOverlay]="vulnerabilityFindingsSideDrawerService.noResultsOverlay()">
      <app-ui-drawer-content-header
        [title]="vulnerabilityFindingsSideDrawerService.selectedFinding()?.plugin?.name || ''"
        [topSectionDataChip]="vulnerabilityFindingsSideDrawerService.headerTopSectionDataChip()"
        [topSectionPills]="vulnerabilityFindingsSideDrawerService.headerPills()"
        [bottomSectionDataChipsTop]="vulnerabilityFindingsSideDrawerService.headerBottomSectionDataChipsTop()"
        [bottomSectionDataChipsBottom]="vulnerabilityFindingsSideDrawerService.headerBottomSectionDataChipsBottom()"
        [bottomSectionKpiDrawers]="vulnerabilityFindingsSideDrawerService.headerBottomSectionKpiDrawers()"
      ></app-ui-drawer-content-header>
      <app-ui-drawer-section
        [title]="this.findingsTexts.vulnerability_findings.side_drawer.plugin_output"
        [subtitle]="vulnerabilityFindingsSideDrawerService.lastHitString()"
        [subSections]="vulnerabilityFindingsSideDrawerService.outputSubSections()"
        [actionButtons]="[{
                        variant: ActionButtonVariant.copy,
                        textToCopy: vulnerabilityFindingsSideDrawerService.output(),
                        showLabel: true,
                      }]"
      ></app-ui-drawer-section>
      <app-ui-drawer-section [title]="this.findingsTexts.vulnerability_findings.side_drawer.vulnerability_details"
                             [subSections]="vulnerabilityFindingsSideDrawerService.vulnerabilitySubSections()"
      ></app-ui-drawer-section>
      @if (vulnerabilityFindingsSideDrawerService.selectedFinding() && vulnerabilityFindingsSideDrawerService.selectedFinding()?.asset) {
        <app-ui-drawer-section [title]="this.findingsTexts.vulnerability_findings.grid.affected_asset"
                               [actionButtons]="[{
                            variant: ActionButtonVariant.link,
                            title: findingsTexts.vulnerability_findings.side_drawer.affected_asset.link,
                            path: vulnerabilityFindingsSideDrawerService.assetExternalURL(),
                            isExternal: true,
                          }]"
                               [subSections]="vulnerabilityFindingsSideDrawerService.affectedAssetSubSections()"
        ></app-ui-drawer-section>
      }
    </app-ui-drawer>
  }
  @case (TabQueryParams.PolicyViolations) {
    <app-ui-drawer [isOpen]="policyFindingsSideDrawerService.isDrawerOpen()" (closed)="policyFindingsSideDrawerService.closeDrawer()"
                   [isLoading]="policyFindingsSideDrawerService.isLoading()"
                   [tabs]="policyFindingsSideDrawerService.tabs()"
                   [tabConfig]="policyFindingsSideDrawerService.tabConfig"
                   [isEmpty]="policyFindingsSideDrawerService.isEmpty()"
                   [menuItems]="policyFindingsSideDrawerService.menuItems()"
                   (tabChanged)="onPolicyDrawerTabChanged($event)"
    >
      <app-ui-drawer-content-header
        [title]="policyFindingsSideDrawerService.selectedFinding()?.pluginName || ''"
        [pipedTitle]="policyFindingsSideDrawerService.selectedFinding()?.policy?.title || ''"
        [topSectionDataChip]="policyFindingsSideDrawerService.headerTopSectionDataChip()"
        [topSectionPills]="policyFindingsSideDrawerService.headerPills()"
        [bottomSourceDestination]="policyFindingsSideDrawerService.headerSourceDestination()"
        [bottomSectionDataChipsBottom]="policyFindingsSideDrawerService.headerBottomSectionDataChipsBottom()"
      ></app-ui-drawer-content-header>

      @if (policyFindingsSideDrawerService.isDrawerOpen()) {
        <app-ui-drawer-section
          [title]="policyFindingsSideDrawerService.getCurrentTabTitle()"
          [subtitle]="policyFindingsSideDrawerService.getCurrentTabSubTitle()"
          [actionButtons]="policyFindingsSideDrawerService.getCurrentActionButton()"
          [subSections]="policyFindingsSideDrawerService.getDrawerSectionsForCurrentTab()"
        ></app-ui-drawer-section>
      }
    </app-ui-drawer>
  }
}
